import React from 'react';
import Popover from 'components/shared/popover';

const RSVPPopover = ({
  status,
  changeAttendanceStatus,
  removeAttendance,
  hide,
}) => (
  <Popover
    dismissCallback={hide}
    position="right"
    styleName="AttendanceRSVP--Popover minw-150"
  >
    <div className="fw-b">Change Status</div>
    {status !== 'will_attend' && (
      <button
        type="button"
        onClick={() => changeAttendanceStatus('will_attend')}
        className="u-resetBtn AttendanceRSVP--PopoverButton"
      >
        {t('in_person_training.attendance.status.accepted')}
      </button>
    )}
    {status !== 'will_not_attend' && (
      <button
        type="button"
        onClick={() => changeAttendanceStatus('will_not_attend')}
        className="u-resetBtn AttendanceRSVP--PopoverButton"
      >
        {t('in_person_training.attendance.status.declined')}
      </button>
    )}
    <button
      type="button"
      onClick={() => removeAttendance()}
      className="u-resetBtn AttendanceRSVP--PopoverButton"
    >
      {t('in_person_training.event_overview.attendance.remove_guest')}
    </button>
  </Popover>
);

export default RSVPPopover;
